import React, { useState } from 'react';
import { View } from 'react-native-web';
import {
  Add_recipient_manually_icon,
  changes_apply_contact,
  Display_recipient_avatars,
  getSubCategoryId,
  SkipContactScreen,
} from '../../../utils/DictionaryManagementUtils';
import SwitcherPanel from '../Buttons/SwitcherPanel';
import Details from '../Text/Details';
import ContactListColors from './ContactListColors';
import { arrangeScreenInJson } from '../../../screens/ScreensOrdering';
import OpenBoxPanel from '../Buttons/OpenBoxPanel';

//= ========================================================================

const ContactListContainer = ({
  globJSON,
  onConfigChanged,
  resetAvatarColors,
  onAvatarValueChanged,
  showAvatarInContactLists,
  colorList,
  selectedScreen,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const [isBoxOpen, setBoxOpen] = useState(false);

  return (
    <View>
      <View style={{ zIndex: 2 }}>
        {globJSON.configurations.services[subCategoryId].recipient.add_recipient_manually && (
        <OpenBoxPanel
          isBoxOpen={isBoxOpen}
          text={Add_recipient_manually_icon}
          chosenValue={globJSON.configurations.services[subCategoryId].recipient.contact_image}
          valuesMap={SkipContactScreen}
          onPress={() => {
            setBoxOpen(!isBoxOpen);
          }}
          onValueChanged={(newSelection) => {
            globJSON.configurations.services[subCategoryId].recipient.contact_image = newSelection;
            arrangeScreenInJson(globJSON, onConfigChanged);
          }}
          noPadding
          rightOffset={0}
          topOffset={34}
        />
        )}
      </View>
      <SwitcherPanel
        text={Display_recipient_avatars}
        value={showAvatarInContactLists}
        onValueChanged={(value) => {
          onAvatarValueChanged(value);
        }}
        marginTop={16}
      />
      {showAvatarInContactLists && (
        <ContactListColors globJSON={globJSON} onConfigChanged={onConfigChanged} colorList={colorList} resetAvatarColors={resetAvatarColors} />)}
      <Details marginTop={24} marginBottom={0}>{changes_apply_contact}</Details>
    </View>
  );
};
export default ContactListContainer;
